module.exports = __webpack_public_path__ + "img/assignment-success.74daabfb.png";